"use client";

import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type Props = {
  className?: string;
  children: ReactNode;
  minHeight?: number | string;
};

export function FrostBorderCard({ className, children, minHeight }: Props) {
  return (
    <section
      className={cn(
        "relative w-full h-full min-w-0 overflow-hidden backdrop-blur-xl rounded-[12px] bg-white/5",
        className,
      )}
      style={minHeight ? { minHeight } : undefined}
    >
      {children}

      <div className="absolute inset-0 z-[4] pointer-events-none rounded-[12px]">
        <div
          className="w-full h-full rounded-[12px] absolute inset-0"
          style={{
            background:
              "radial-gradient(circle at top left, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.15) 40%, transparent 60%),\n              radial-gradient(circle at top right, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.08) 40%, transparent 60%),\n              radial-gradient(circle at bottom left, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.08) 40%, transparent 60%),\n              radial-gradient(circle at bottom right, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.15) 40%, transparent 60%),\n              rgba(255,255,255,0.04)",
            WebkitMask:
              "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
            WebkitMaskComposite: "xor",
            maskComposite: "exclude",
            padding: "1px",
            opacity: 1,
          }}
        />
      </div>
    </section>
  );
}
